import React from "react";

function AboutTransparency() {
  return (
    <div className="landing-root">
      <div className="background-particles" />

      <section className="landing-section glass-card">
        <h2 className="neon-title">Multiversal Blockchain Tracer</h2>        
        <h2 className="neon-title">About & Transparency</h2>

        <p className="section-subtitle">
          Clarity, honesty, and trust are core principles of this dApp.
        </p>

        <h3>What This dApp Is</h3>
        <p>
          Multiversal Blockchain Tracer is a <strong>read-only blockchain
          analysis dashboard</strong>. It allows anyone to explore public wallet
          balances and token distributions across multiple blockchains using
          publicly available on-chain data.
        </p>

        <h3>What This dApp Is NOT</h3>
        <ul>
          <li>❌ Not a wallet</li>
          <li>❌ Not a trading platform</li>
          <li>❌ Not a custodial service</li>
          <li>❌ Not financial or investment advice</li>
          <li>❌ Does not connect to or control wallets</li>
        </ul>

        <h3>How “AI” Is Used</h3>
        <p>
          References to “AI” or “SmartInsight” in this dApp describe
          <strong>rule-based analysis</strong>, scoring models, and heuristics
          inspired by analytical techniques.  
          No autonomous decision-making, prediction, or trading occurs.
        </p>

        <h3>Data Sources</h3>
        <ul>
          <li>🔹 Covalent — on-chain balances & transactions</li>
          <li>🔹 CoinGecko — market prices & metadata</li>
          <li>🔹 ENS — name resolution for Ethereum addresses</li>
        </ul>

        <h3>Privacy & Anonymity</h3>
        <p>
          This dApp does <strong>not</strong> require wallet connections, private
          keys, or transaction signing. Email registration is used solely for
          access control and abuse prevention.
        </p>

        <h3>Who Built This & Why</h3>
        <p>
          Built independently to promote transparency, education, and trust in
          Web3. The goal is to make blockchain data easier to understand without
          compromising user privacy.
        </p>

        <h3>Who This Tool Is For</h3>
        <ul>
          <li>Researchers & analysts</li>
          <li>Developers & builders</li>
          <li>Students & learners</li>
          <li>Anyone curious about blockchain transparency</li>
        </ul>

        <p className="section-subtitle" style={{ marginTop: "1.5rem" }}>
          Transparency is not a feature — it’s a foundation.
        </p>
      </section>
    </div>
  );
}

export default AboutTransparency;
